import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  EmailRequestSchema,
  EmailResponseSchema,
} from '../shared/schemas/Email.js';

//TODO: remove this API when newGhostEmailApi FF is enabled on PROD
export const get = defaultClient.query({
  url: 'datintell/v1/external_integrations/ghost_subscribers/' as const,
  method: 'GET',
  responseSchema: EmailResponseSchema,
  querySchema: z.object({
    integrationId: z.string(),
  }),
  snakeCaseQueryParams: true,
});

//TODO: remove this API when newGhostEmailApi FF is enabled on PROD
export const saveEmails = defaultClient.mutation({
  url: 'datintell/v1/external_integrations/ghost_subscribers/' as const,
  method: 'POST',
  querySchema: z.object({
    integrationId: z.string(),
    platformType: z.string(),
  }),
  responseSchema: EmailResponseSchema,
  requestSchema: EmailRequestSchema,
  processResponse: (data) => data,
  snakeCaseQueryParams: true,
  onSuccess: (queryClient) => {
    get.invalidateAll(queryClient, {});
  },
});

//TODO: rename this API to "get" when newGhostEmailApi is enabled on PROD
export const getV2 = defaultClient.query({
  url: 'recommendations/notifications/ghost_subscribers',
  method: 'GET',
  responseSchema: EmailResponseSchema,
  querySchema: z.object({
    platformName: z.string(),
  }),
  snakeCaseQueryParams: true,
});
//TODO: rename this API to "saveEmails" when newGhostEmailApi is enabled on PROD
export const saveEmailsV2 = defaultClient.mutation({
  url: 'recommendations/notifications/ghost_subscribers' as const,
  method: 'POST',
  responseSchema: EmailResponseSchema,
  requestSchema: z.object({
    integrationId: z.number(),
    platformName: z.string(),
    emails: z.array(z.string()),
  }),
  processResponse(data) {
    return data;
  },
  onSuccess: (queryClient) => {
    getV2.invalidateAll(queryClient, {});
  },
});

export type SaveEmailsRequestSchemaType = z.infer<typeof EmailRequestSchema>;
